import { useEffect, useRef, useState } from "react";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { LiaPlusCircleSolid } from "react-icons/lia";

import { FiMinusCircle } from "react-icons/fi";
import { MdOutlineDeleteOutline } from "react-icons/md";
import axiosInstance from "../../Services/axios";
import defaultimg from "../../Assets/Images/default-placeholder.png";
import { toast } from "react-toastify";
// Menu
import vegIcon from "../../Assets/Images/vegpngoutput.png"
import eggIcon from "../../Assets/Images/eggpngoutput.png"
import nonvegIcon from "../../Assets/Images/nomvegoutput.png"
// Addon  
import { showToast } from "../../Components/toastConfig/ToastConfig";
import { CgClose } from "react-icons/cg";
import { FaRegSquare, FaSquareCheck } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { addOrRemoveProductCart, getProductCartDetails } from "../../Services/api";
import NodeaxiosInstance from "../../Services/nodeaxios";

const ProductBasket = () => {

  const [cartId, setCartId] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { merchantId, flowtype, offer_type, offer_count, flow } = location.state || {};

  const [cardDetails, setCardDetails] = useState([]);
  const [shipingtype, setShipingtype] = useState();
  const [deleteitem, setDeleteitem] = useState()
  const [data, setData] = useState("")
  // Offer or Membership 
  const [cardStatus, setCardStatus] = useState();
  const [cardType, setcardType] = useState();
  const [cardId, setcardId] = useState();


  // Addon 
  const addonModalRef = useRef(null);
  const addonEditeModalRef = useRef(null);

  const [productid, setProductid] = useState('')
  const [productCost, setProductCost] = useState('')
  const [addonsCost, setAddonsCost] = useState('')
  const [selectedAddons, setSelectedAddons] = useState([])
  const [productCount, setProductCount] = useState(0);
  const [cartDetails, setCartDetails] = useState([""])
  const [selectItem, setSelectItem] = useState('')

  const flowtypeValue = flowtype == "EDIT_ORDER" ? "EDIT_ORDER" : flowtype;
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [vendorType, setVendorType] = useState()
  const [productAdd, setProductAdd] = useState(0)
  const [totalproductCount, setTotalproductCount] = useState()

  const [modalOpen, setModalOpen] = useState(false);
  const toggleRemoveProduct = () => {
    setModalOpen(!modalOpen)
  }

  const state = useSelector((state) => state);
  const [userData, serUserData] = useState(state?.userAuth?.user);

  useEffect(() => {
    let productCart = localStorage.getItem("productCart") ? JSON.parse(localStorage.getItem("productCart")) : "";
    setCartId(productCart?.cartId ? productCart?.cartId : "");
    setShipingtype(productCart?.shipping_type);

    let appliedCard = JSON.parse(localStorage.getItem("appliedCard"));
    setCardStatus(appliedCard?.cardStatus ? appliedCard?.cardStatus : "")
    setcardType(appliedCard?.cardType ? appliedCard?.cardType : "")
    setcardId(appliedCard?.cardId ? appliedCard?.cardId : "")


    let cartItems = JSON.parse(localStorage.getItem("cart_items"));

    // if (productCart?.loyaltyDetail) {

    // }
    // else if (cartItems?.cart_count == 0) {
    //   navigate(-1)
    // }

  }, []);

  useEffect(() => {
    if (cartId != "") {
      getcardDetail();
      getVendorStatuses()
    }

  }, [cartId, deleteitem]);



  const getcardDetail = async () => {
    try {
      let reqData = {
        vendor_id: merchantId,
        cart_id: cartId,
        flow_type: flowtype == "EDIT_ORDER" ? "EDIT_ORDER" : "ORDER"

      };

      let res = await getProductCartDetails(reqData);
      if (res?.states == 200) {
        setCardDetails(res.data.cart);

        setData(res.data)
        if (res.data.cart) {
          const totalCount = res.data.cart.reduce((acc, item) => acc + Number(item.added_count), 0)
          setTotalproductCount(totalCount)

        }
        if (res.data.cart_count == 0) {
          navigate(-1)
        }
        setCartDetails(res.data.cart)

      }
    } catch (err) {
      if (err.response.status == 400 || err.response.status == 500) {
        toast(err.response.data.message, { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1" });
      }
    }
  };


  const Add_Remove_productcount = async (productId, Operation, addon, count) => {
    try {
      const Addition = [];
      if (selectedAddons && selectedAddons.length > 0) {
        selectedAddons.forEach((addon) => {
          Addition.push(...addon.options);
        });
      }



      let reqData = {
        vendor_id: merchantId,
        product_id: productId,
        shipping_type: shipingtype,
        quantity: count ? count : productAdd ? productAdd : 0,
        operation: Operation,
        cart_id: cartId,
        card_status: cardStatus,
        card_type: cardType,
        card_id: cardId,
        addons: Addition || "",
        flow_type: flowtype === "EDIT_ORDER" ? "EDIT_ORDER" : "ORDER",
      };

      let res = addOrRemoveProductCart(reqData)
      if (res?.status == 200) {
        setProductAdd(0)

        const cartItemsFromAPI = res?.data?.cart_items || [];

        const updatedCartItems = cartItemsFromAPI.map(item => ({
          ...item,
          price: productCost,
        }));

        const cart_items = {
          cart_items: updatedCartItems,
          cart_id: res?.data?.cart_id,
          cart_count: updatedCartItems.length,
          sub_total: res?.data?.sub_total,
        };

        localStorage.setItem("cart_items", JSON.stringify(cart_items));

        if (res?.data?.cart_count == "0") {

          let productCart = localStorage.getItem("productCart");

          if (productCart && flowtype != "EDIT_ORDER") {
            let parsedCart = JSON.parse(productCart);
            parsedCart.cartId = "";
            localStorage.setItem("productCart", JSON.stringify(parsedCart));
          }

          localStorage.removeItem('cartid')
          // localStorage.removeItem('appliedCard')
        }



        getcardDetail();

        setProductCount((prevCount) =>
          Operation === "remove" ? prevCount - 1 : prevCount + 1
        );
      }
    } catch (error) {
      toast("Can't add product. Please contact support or try again later.", {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        className: "text-danger toast-style-1",
      });
    }
  };


  const deleteProduct = async () => {
    try {

      let reqData = {
        vendor_id: merchantId,
        product_id: deleteitem.product_id,
        shipping_type: shipingtype,
        quantity: deleteitem.added_count,
        operation: 'remove',
        cart_id: cartId,
        card_status: cardStatus,
        card_type: cardType,
        card_id: cardId,
        flow_type: flowtype === "EDIT_ORDER" ? "EDIT_ORDER" : "ORDER",
      };

      let res = addOrRemoveProductCart(reqData);
      if (res?.states == 200) {
        // Call to get card details
        getcardDetail();

        const cartItemsFromAPI = res?.data?.cart_items || [];
        const updatedCartItems = cartItemsFromAPI.map(item => ({
          ...item,
          price: productCost,
        }));
        const cart_items = {
          cart_items: updatedCartItems,
          cart_id: res?.data?.cart_id,
          cart_count: updatedCartItems.length,
          sub_total: res?.data?.sub_total,
        };

        localStorage.setItem("cart_items", JSON.stringify(cart_items));
        toggleRemoveProduct()
      }
    } catch (error) {
      toast("Can't delete product. Please contact support or try again later.", {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        className: "text-danger toast-style-1",
      });
    }
  };



  const openAddonModal = () => {
    addonModalRef.current.classList.add("show");
    addonModalRef.current.style.display = "block";
    setIsModalOpen(true)
  };

  const closeAddonModal = () => {
    addonModalRef.current.classList.remove("show");
    addonModalRef.current.style.display = "none";
    setIsModalOpen(false)
  };
  const handelEdittoAddonmodel = () => {
    closeEditAddonModal()
    openAddonModal()

    setProductCost((totalPrice) * (productCount))
  }
  const transformDataAndCalculateTotalCost = (rawData, selectedOptions) => {
    let transformedData = [];
    let totalCost = 0;


    if (rawData && rawData.length > 0) {
      rawData.forEach((addon) => {
        let addonObj = {
          addonId: addon.id,
          options: []
        };

        addon.options.forEach((option) => {
          if ((selectedOptions || []).some((id) => Number(id) === Number(option.id))) {
            addonObj.options.push(option.id);
            totalCost += Number(option.price) || 0;
          }
        });

        if (addonObj.options.length > 0) {
          transformedData.push(addonObj);
        }
      });
    }

    return { addons: transformedData, cost: totalCost };
  };


  const selectAddon = (addon, option, price) => {
    let addonId = addon.id;
    let selectedAddonsList = [...selectedAddons];
    let addonName = addon.name;
    let found = false;

    selectedAddonsList.forEach(item => {
      if (item.addonId == addonId) {
        found = true;
        if (!item?.options?.includes(option)) {
          if ((addon.selection_type == 1 && item.options.length > 0) || (addon.selection_type == 2 && Number(addon.max_select) > 0 && item.options.length >= Number(addon.max_select))) {
            toast("You have already selected max addons for this category", {
              position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: 'text-danger toast-style-1'
            });
          } else {
            item.options.push(option);
            setProductCost(Number(productCost) + Number(price));
            setAddonsCost(Number(addonsCost) + Number(price));

          }
        } else {
          item.options = item.options.filter((opt) => opt !== option);
          setProductCost(Number(productCost) - Number(price));
          setAddonsCost(Number(addonsCost) - Number(price));

        }
      }
    });

    if (!found) {
      selectedAddonsList.push({ "addonId": addonId, addonName, "options": [option] });
      setProductCost(Number(productCost) + Number(price));
      setAddonsCost(Number(addonsCost) + Number(price));
    };


    setSelectedAddons(selectedAddonsList);
  }

  const checkIsSelectedAddon = (addonId, option) => {

    let selectedAddonsList = [...selectedAddons];
    let found = false;

    selectedAddonsList.forEach(item => {

      if (item.addonId === addonId) {
        if (item?.options?.includes(option)) {


          found = true;
        }
      }
    });

    return found;
  }



  const checkButtonStatus = () => {


    for (const addon of (selectItem?.addons || [])) {
      const selectedAddon = selectedAddons.find((sel) => sel.addonId == addon.id);
      const selectedOptionsCount = selectedAddon ? selectedAddon.options.length : 0;

      if (addon?.required == 1 && addon.selection_type == 2 && selectedOptionsCount < Math.max(1, Number(addon.min_select) || 0)) {
        toast(`You need to select at least ${Math.max(1, Number(addon.min_select) || 0)} option(s) from the category ${addon.addon_name}`, {
          position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: 'text-danger toast-style-1 toast-custom-style' // Add your custom class here
        });
        return;
      } else if (addon?.required == 1 && addon.selection_type == 1 && selectedOptionsCount <= 0) {

        toast(`You need to select at least 1 option(s) from the category ${addon.addon_name}`,
          { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: 'text-danger toast-style-1 toast-custom-style' });

        return;
      }
    }

    closeAddonModal()
    closeEditAddonModal()

    // if (productCount > Number(selectItem)) {
    Add_Remove_productcount(productid, "add", selectedAddons);
    // }
  }

  const openEditAddonModal = (addons, addedAddons, productid, added_count) => {
    let transformedData = transformDataAndCalculateTotalCost(addons, addedAddons);
    setSelectedAddons(transformedData.addons);
    setProductid(productid);
    setProductCount(added_count)
    setIsModalOpen(true)

    addonEditeModalRef.current.classList.add("show");
    addonEditeModalRef.current.style.display = "block";

  };
  const closeEditAddonModal = () => {
    addonEditeModalRef.current.classList.remove("show");
    addonEditeModalRef.current.style.display = "none";
    setIsModalOpen(false)

  };

  const update_Product = async (productId, Operation, count) => {
    try {
      let addons = [];
      selectedAddons?.map((addon) => {
        addons = [...addons, ...addon.options];
      });


      let reqData = {
        vendor_id: merchantId,
        product_id: productId,
        shipping_type: shipingtype,
        quantity: count,
        operation: Operation,
        cart_id: cartId,
        card_status: cardStatus,
        card_type: cardType,
        card_id: cardId,
        addons: addons ? addons : "",
        flow_type: flowtype == "EDIT_ORDER" ? "EDIT_ORDER" : "ORDER"

      };


      let res = await addOrRemoveProductCart(reqData);
      if (res?.status == 200) {
        setProductAdd(0)
        const cartItemsFromAPI = res?.data?.cart_items || [];

        const updatedCartItems = cartItemsFromAPI.map(item => ({
          ...item,
          price: productCost,
        }));

        const cart_items = {
          cart_items: updatedCartItems,
          cart_id: res?.data?.cart_id,
          cart_count: updatedCartItems.length,
          sub_total: res?.data?.sub_total,
        };

        localStorage.setItem("cart_items", JSON.stringify(cart_items));

        getcardDetail();
        setSelectedAddons([]);
        closeEditAddonModal()
      }

    } catch (error) {
      toast("can't Update product please content pingle are Try again later", { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
    }
  };
  const confirmUpdate = () => {
    let ProductItem = cartDetails
    var ProductHave = ProductItem?.some((obj) => obj.product_id == productid);


    ProductItem?.map((Cartdata, id) => {
      if (Cartdata.product_id == productid) {
        if (Cartdata.added_count > productCount) {
          update_Product(productid, 'remove', productAdd);
        } else if (productCount > Cartdata.added_count) {
          let count = ''
          if (productCount == Cartdata.added_count) {
            count = 0
          } else {
            count = productCount - Cartdata.added_count
          }
          update_Product(productid, 'add', count);
        } else {
          closeEditAddonModal()
        }
      }
    })

  }


  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    let calculatedTotalPrice = 0;

    if (cardDetails?.length > 0) {
      cardDetails.forEach((item) => {
        if (productid === item.product_id) {
          calculatedTotalPrice += parseFloat(item.price) || 0;

          item?.addons.forEach((addon) => {
            addon?.options.forEach((option) => {
              if (item.added_addons?.includes(option?.id)) {
                calculatedTotalPrice += parseFloat(option?.price) || 0;
              }
            });
          });
        }
      });
    }
    setTotalPrice(calculatedTotalPrice);
  }, [cardDetails, productid]);


  const getVendorStatuses = async () => {
    try {
      const response = await NodeaxiosInstance.post('vendor/profile-details-without-login', { vendor_id: merchantId });
      if (response.status == 200) {
        const data = response.data;

        setVendorType(data?.vendor_profile?.vendor_details?.vendor_type_id);
      }
    } catch (error) {

    }
  }



  return (
    <div>
      <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white ">
        <div className="d-flex justify-content-between align-items-center ms-2 me-2">
          <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button" onClick={() => navigate(-1)} />
          <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
            Product Basket
          </div>
        </div>
      </div>

      {/* Edit addon model   */}
      <div className="offcanvas addOnModalOffcancas" tabIndex="-1" ref={addonEditeModalRef} >
        <div className=" d-flex justify-content-end mt-1" onClick={() => closeEditAddonModal()}>
          <div className="fs-20 ff-poppins-semiBold me-2 crossContainer" ><CgClose /> </div>
        </div>
        <div className="addOnModel_scroll insideAddon">
          <div className="editAddonTitleCont">
            <div className="editAddonTitle">Your Addons</div>
            <div className="editaddonBtn" onClick={() => handelEdittoAddonmodel(productid)}>Edit</div>
          </div>
          {cardDetails?.length > 0 && (
            <div
              className="addonProductListCont "
              style={{ gap: "10px", margin: "19px 0px" }}
            >
              {cardDetails?.map((item, itemIndex) => {
                if (productid !== item.product_id) return null;

                const selectedAddons =
                  item?.addons?.flatMap((addon) =>
                    addon?.options?.filter((option) =>
                      item?.added_addons?.includes(option?.id)
                    )
                  ) || [];

                return selectedAddons.length > 0 ? (
                  selectedAddons.map((option, optionIndex) => (
                    <div
                      className="addonProductCont"
                      key={`${itemIndex}-${optionIndex}`}
                      style={{ margin: "0px 0px" }}
                    >
                      <div className="addonProductLeft">
                        {(option?.type == "1" || option?.type == "2") && (
                          <img
                            src={option?.type == "1" ? vegIcon : nonvegIcon}
                            height="13px"
                            width="13px"
                          />
                        )}
                        <div className="addonProductName">{option?.name}</div>
                      </div>
                      <div className="addonProductRight">
                        <div className="addonPrice" style={{ lineHeight: "16px" }}>
                          +&nbsp;<span className="rupeeIcon">₹</span>
                          {option?.price}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div
                    className="ff-poppins-semiBold w-100 text-center fs-12 mt-1 me-1"
                    key={`no-addon-${itemIndex}`}
                  >
                    No addons added
                  </div>
                );
              })}
            </div>

          )}

          <div className="mt-3" style={{ backgroundColor: '#fff', position: "sticky", bottom: 0, width: '100%' }}>
            <div className=" ">
              {cardDetails?.length > 0 &&
                cardDetails.map((item) => (
                  <div className="ff-poppins-regular ">
                    {productid == item.product_id && item.added_count > 0 && (

                      <div>
                        <div className="d-flex justify-content-between">
                          <div className="  d-flex fs-14 col-4  ">
                            <div className="col-2">
                              <FiMinusCircle
                                className="  primary-text fontSizeCountIcon"
                                onClick={() => {
                                  setProductCount((prevCount) => {
                                    const newCount = Math.max(prevCount - 1, 0);
                                    setProductCost(item.price);
                                    setProductAdd(productAdd + 1)
                                    if (newCount == 0) {
                                      Add_Remove_productcount(item.product_id, "remove", '', 1);
                                      closeEditAddonModal()
                                    }
                                    return newCount;
                                  });

                                }}
                              />
                            </div>
                            <div className=" col-2 ms-1 d-flex justify-content-center">
                              {productCount}
                            </div>
                            <div className="col-2">
                              <LiaPlusCircleSolid
                                className={`primary-text fontSizeCountIcon 
                                  ${Number(productCount) >= Number(item.max_allowed_quantity || Infinity) ||
                                    Number(productCount) >= Number(item.stock_quantity)
                                    ? "opacity_Cls rounded-circle"
                                    :

                                    ""
                                  }`}
                                onClick={() => {

                                  const stockQty = Number(item.stock_quantity);
                                  const maxQty = item.max_allowed_quantity ? Number(item.max_allowed_quantity) : Infinity;
                                  if (productCount >= stockQty) {
                                    toast("No more stock left for this product", { position: "bottom-center", autoClose: 2000, hideProgressBar: true, className: "text-danger toast-style-1", });
                                  } else if (productCount >= maxQty) {
                                    toast("You have reached maximum order product", {
                                      position: "bottom-center",
                                      autoClose: 2000,
                                      hideProgressBar: true,
                                      className: "text-danger toast-style-1",
                                    });
                                  } else {
                                    setProductAdd(productAdd + 1)
                                    setProductCount((prevCount) => prevCount + 1);
                                    setProductid(item.product_id);
                                  }
                                }}
                              />

                            </div>
                          </div>
                          <div className="ff-poppins-semiBold fs-14 primary-text">
                            Cost :&nbsp;<span className="rupeeIcon">₹</span>{(totalPrice) * (productCount)}
                          </div>
                        </div>
                        <div className="col-12">
                          <button type="button" className="btn-type-1   ff-poppins-semiBold mt-2 fs-14 w-100 primary-bg border-0 text-white justify-content-center d-flex align-items-center"
                            onClick={() => confirmUpdate()} >
                            Confirm
                          </button>
                        </div>

                      </div>
                    )}
                  </div>
                )
                )}
            </div>
          </div>

        </div>
      </div>

      {/* Add addon model  */}
      <div className="offcanvas addOnModalOffcancas" tabIndex="-1" ref={addonModalRef} >
        <div className=" d-flex justify-content-end mt-1" onClick={() => { closeAddonModal(); setSelectedAddons([]) }}>
          <div className="fs-20 ff-poppins-semiBold me-2 crossContainer" ><CgClose /> </div>
        </div>
        <div className="insideAddon  " >
          <div className="addonContainer addOnModel_scroll">
            {cardDetails?.length > 0 &&
              cardDetails?.map((item, productItemIndex) => {
                if (productid !== item.product_id) return null;

                return item?.addons ? (
                  item.addons.map((addon, addonIndex) => (
                    <div className="AddonCategoryCont" key={`${productItemIndex}-${addonIndex}`}>
                      <div className="addonCatgoryContTop">
                        <div className="addonCategoryTitle">Choose {addon?.addon_name}</div>
                        <div className="addonCategorySubtitle">Select any (Optional)</div>
                      </div>
                      <div className="addonProductListCont">
                        {addon?.options?.map((option, optionIndex) => (
                          <div className="addonProductCont" key={`${addonIndex}-${optionIndex}`}>
                            <div className="addonProductLeft">
                              {(option?.type == "1" || option?.type == "2") && (
                                <img
                                  src={option?.type == "1" ? vegIcon : nonvegIcon}
                                  height="13px"
                                  width="13px"
                                />
                              )}
                              <div className="addonProductName">{option?.name}</div>
                            </div>
                            <div className="addonProductRight">
                              <div className="addonPrice">
                                +&nbsp;<span className="rupeeIcon">₹</span>{option?.price}
                              </div>
                              {checkIsSelectedAddon(addon.id, option.id) ? (
                                <div
                                  onClick={() => {
                                    selectAddon(addon, option.id, option?.price, option);
                                    setProductid(addon?.product_id);
                                  }}
                                  className="checkBoxContainer"
                                >
                                  <FaSquareCheck size={18} />
                                </div>
                              ) : (
                                <div
                                  onClick={() => {
                                    selectAddon(addon, option.id, option?.price, option);
                                    setProductid(addon?.product_id);
                                  }}
                                  className="checkBoxContainer"
                                >
                                  <FaRegSquare size={18} />
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="ff-poppins-semiBold w-100 text-center fs-12 mt-1 me-1" key={`no-addon-${productItemIndex}`}  >
                    No addons added
                  </div>
                );
              })}
          </div>

        </div>
        <div style={{ backgroundColor: '#fff', position: "sticky", bottom: 0, width: '100%' }}>
          <div className=" p-1  ">
            <p className="m-0 d-flex justify-content-end primary-text ff-poppins-semiBold fs-14 mb-1 me-3">
              Cost : &nbsp; <span className="rupeeIcon">₹</span>{productCost}</p>
            <button type="button" className="btn-type-1 ff-poppins-semiBold fs-14 w-100 primary-bg border-0 text-white justify-content-center d-flex align-items-center"
              onClick={() => checkButtonStatus()}  >
              Confirm
            </button>
          </div>

        </div>
      </div>



      {/* position-relative */}
      <div className="offcanvas-parentType3 position-relative scroller-style-y">

        <div className="offcanvas-parentType3 ">
          {/* position-relative */}
          <div className="doorStepService" style={{ marginBottom: "60px" }}>
            {cardDetails.map((item, index) => {
              return (
                <div className="productDiv">
                  <div className="col-3 ">
                    <div className="imgBox position-relative productImageDiv ">
                      <img src={item.cover_image.image == "" ? defaultimg : item.cover_image.image_url} height="90px" width="90px" className="  rounded-3" />
                    </div>
                  </div>
                  <div className="col-9">
                    <div className=" ms-2">
                      <div className="d-flex align-items-center">
                        {vendorType == "9" &&
                          <img src={item.food_type == "1" ? vegIcon : item.food_type == "2" ? nonvegIcon : item.food_type == "3" ? eggIcon : ""} height="13px" width="13px" className="me-1" />
                        }
                        <div className="ff-poppins-semiBold fs-12"> {item.product_name}  </div>
                      </div>
                      <div className="ff-poppins-semiBold  fs-12 me-1 m-0">
                        <span className="rupeeIcon ">₹</span>{item.price}
                        {item.benefit ? <span className="primary-text ms-1 ff-poppins-regular fs-11">({item.benefit_lable}) </span> : ""}
                      </div>
                      <p className="ff-poppins-semiBold primary-text fs-9 m-0"> {item.unit_quantity} {item.unit_type_name}  </p>

                      <div className="moreDetailsDiv primary-text">
                        <p className="moreInfobtn ff-poppins-semiBold fs-10 px-0 m-0"
                          onClick={() => navigate(`/product/${merchantId}/${item.product_id}`, {
                            state: { productId: item.product_id, merchantId, },
                          })}  >
                          More details
                        </p>
                        <IoIosArrowDown className="fw-bold productWeightBasket primary-text" />

                      </div>
                      {
                        item?.stock_status == 1 ?
                          <p className="ff-poppins-medium primary-text  fs-9 m-0 p-0 m-0"> {item.stock_quantity - item.added_count} left </p>
                          : ""
                      }
                      <div className='d-flex justify-content-between'>

                        {flow == "LoyaltyProduct" || data?.applied_card_detail?.offer_type == '2' ? "" :
                          <div className="row align-items-center  col-4 gx-0">
                            <div className="row d-flex justify-content-between w-100 gx-0">
                              <div className="col-3">
                                <FiMinusCircle className="w-100 fs-18 primary-text" onClick={() => {
                                  if (item.added_count == 1) {
                                    toggleRemoveProduct();
                                    setDeleteitem(item)
                                  } else {
                                    Add_Remove_productcount(item.product_id, "remove", "", 1)
                                  }
                                }} />
                              </div>
                              <div className="col-3 ff-poppins-regular  d-flex justify-content-center align-items-end primary-text">
                                {item.added_count}
                              </div>
                              <div className="col-3">
                                <LiaPlusCircleSolid
                                  className={`w-100 primary-text fs-21 ${item.added_count == item.max_allowed_quantity
                                    || (item.stock_status == 1 && item.added_count >= item.stock_quantity) ?
                                    "opacity_Cls rounded-circle" :
                                    data?.applied_card_detail?.offer_type == '4' ?
                                      "opacity_Cls rounded-circle" :
                                      ""}`}
                                  onClick={() => {
                                    setSelectItem(item);

                                    const addedCount = Number(item.added_count);
                                    const maxQty = Number(item.max_allowed_quantity) || Infinity;
                                    const stockQty = Number(item.stock_quantity);

                                    if (data?.applied_card_detail?.offer_type == '4') {

                                    }
                                    else {
                                      if (addedCount >= maxQty || (item.stock_status == 1 && addedCount >= stockQty)) {
                                        if (addedCount >= maxQty) {
                                          showToast("You have reached maximum order product");
                                        } else if (item.stock_status == 1 && addedCount >= stockQty) {
                                          showToast("No more stock left for this product");
                                        }
                                        return;
                                      }

                                      if (!item.addons || item.addons.length === 0) {
                                        Add_Remove_productcount(item.product_id, "add", "", 1);
                                      } else {
                                        openEditAddonModal(item.addons, item.added_addons, item.product_id, addedCount);
                                      }
                                    }
                                  }}
                                />

                              </div>
                            </div>
                          </div>
                        }
                        {flow == "LoyaltyProduct" || data?.applied_card_detail?.offer_type == '2' ? "" :
                          <div className="col-2 deleteIconProductBasket me-3">
                            <MdOutlineDeleteOutline className="ms-2" onClick={() => { setDeleteitem(item); toggleRemoveProduct() }} />
                          </div>
                        }
                      </div>

                    </div>
                  </div>

                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="reviewAndPayDiv-3" style={{ backgroundColor: "", position: 'sticky', width: 'unset' }}>
        <button className="reviewAndPayBtnProduct primary-bg ff-balooPaaji2-bold" onClick={() => {
          if (offer_type == 4 && offer_count != cardDetails.length) {
            toast(`Please select exactly  ${offer_count} products to continue.`, {
              position: "bottom-center",
              autoClose: 2000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              className: "text-danger toast-style-1",
            });
          }
          else if (data?.applied_card_detail?.offer_type == "1" && data?.applied_card_detail?.min_quantity > totalproductCount) {
            return toast(`This offer requires a minimum purchase of  ${data?.applied_card_detail?.min_quantity} items`, {
              position: "bottom-center",
              autoClose: 2000,
              hideProgressBar: true,
              className: "text-danger toast-style-1",
            });
          }
          else if (data?.applied_card_detail?.min_pur_status == "1" && data?.applied_card_detail?.min_pur_amount > Number(data.sub_total)) {
            return toast(`A minimum purchase value of ₹ ${data?.applied_card_detail?.min_pur_amount} is required to use this offer.`, {
              position: "bottom-center",
              autoClose: 2000,
              hideProgressBar: true,
              className: "text-danger toast-style-1",
            });
          }
          else if (offer_type == 4 && offer_count == cardDetails.length) {
            navigate("/ReviewPay", { state: { merchantId, flowtype: flowtypeValue, flow: flow } })
          }
          else {
            navigate("/ReviewPay", { state: { merchantId, flowtype: flowtypeValue, flow: flow } })
          }
        }}
        >
          Proceed to Buy
        </button>

      </div>


      {/* 
      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mainModal text-dark ">
          <div class="modal-content p-3">
            <div class="modal-body text-center ff-balooPaaji2-bold mb-3">
              Are you sure want to delete the product?
            </div>
            <div class="modalFooter">
              <button type="button" class="btn btn-secondary ff-balooPaaji2-bold" data-bs-dismiss="modal"   >
                Cancel
              </button>
              <button type="button" class="btn btn-danger ff-balooPaaji2-bold" onClick={() => deleteProduct()} data-bs-dismiss="modal"  >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div> */}
      {modalOpen && (
        <>
          <div className="modal-backdrop fade show"></div>

          <div className="modal fade show successModal" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-modal="true">
            <div className="modal-dialog modal-dialog-centered modal-sm m-0" style={{ maxWidth: "360px" }}>
              <div className="modal-content rounded-3">
                <div className="modal-body p-4">
                  <div className='text-center ff-poppins-semiBold fs-14 '>Are you sure want to delete the product?</div>
                  <div className="d-flex text-center justify-content-between mt-3">
                    <div className="logout-modal-btn text-light primary-bg" onClick={() => deleteProduct()}>Yes</div>
                    <div className="logout-modal-btn primary-text primary-bg-light  ms-3" onClick={() => toggleRemoveProduct()}>No</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {isModalOpen && <div className="modal-backdrop fade show"></div>}

    </div >
  );
};

export default ProductBasket;
